<template>
  <div class="share" :class="{'share--standalone': standalone}">
    <div class="share-inner">
      <h4 class="share__heading">Share:</h4>
      <ul class="share__btns">
        <li class="share__btn-item">
          <button :disabled="disabledShare" @click="postToSocial('facebook')" class="share-btn">
            <svg
              rel="nofollow"
              aria-hidden="true"
              aria-labelledby="titleFacebook2"
              data-prefix="fab"
              data-icon="facebook-square"
              class="share-btn__img"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <title id="titleFacebook2">Facebook</title>
              <path
                fill="currentColor"
                d="M448 80v352c0 26.5-21.5 48-48 48h-85.3V302.8h60.6l8.7-67.6h-69.3V192c0-19.6 5.4-32.9 33.5-32.9H384V98.7c-6.2-.8-27.4-2.7-52.2-2.7-51.6 0-87 31.5-87 89.4v49.9H184v67.6h60.9V480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
              ></path>
            </svg>
            <span class="sr-only">Share design to Facebook</span>
          </button>
        </li>
        <li class="share__btn-item">
          <button :disabled="disabledShare" @click="postToSocial('twitter')" class="share-btn">
            <svg
              aria-hidden="true"
              aria-labelledby="titleTwitter"
              data-prefix="fab"
              data-icon="twitter-square"
              class="share-btn__img"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <title id="titleTwitter">Twitter</title>
              <path
                fill="currentColor"
                d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"
              ></path>
            </svg>
            <span class="sr-only">Share design to Twitter</span>
          </button>
        </li>
        <li class="share__btn-item">
          <button :disabled="disabledShare" @click="postToSocial('pinterest')" class="share-btn">
            <svg
              aria-hidden="true"
              aria-labelledby="titlePinterest"
              data-prefix="fab"
              data-icon="pinterest-square"
              class="share-btn__img"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <title id="titlePinterest">Pinterest</title>
              <path
                d="M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
              ></path>
            </svg>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { EventBus } from "@/eventBus";

export default {
  name: "share",
  props: {
    genericShare: {
      type: Boolean,
      default: false
    },
    standalone: {
      type: Boolean,
      default: false
    },
    disabledShare: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    shareImageURL() {
      return store.state.socialImageURL;
    }
  },
  methods: {
    getShareParameters() {
      const shareQuery = this.$store.state.configuration.ConfigId;
      console.log(shareQuery);
      return shareQuery;
    },
    urlEncode(text) {
      return encodeURIComponent(text);
    },
    postToSocial(network) {
      if (this.genericShare) {
        EventBus.$emit("genericShareModal");
        EventBus.$emit("getShareImage");
      } else {
        const shareUrlPrefix = encodeURIComponent(
          `https://studio.ultimateears.com/${this.$store.state.locale}/social/`
        );
        const shareText = encodeURIComponent(
          "I just designed my new Boom. What do you think?"
        );
        const shareImageURL = encodeURIComponent(this.shareImageURL);
        const twitterShareText =
          shareText + encodeURIComponent(" #ultimateears #myBOOM3");
        const hashtag = encodeURIComponent("#myBOOM3");
        let url = "";
        if (network === "facebook") {
          url = `https://www.facebook.com/sharer.php?u=${shareUrlPrefix}${this.getShareParameters()}&hashtag=${hashtag}`;
        } else if (network === "twitter") {
          url = `https://twitter.com/intent/tweet?text=${twitterShareText}&url=${shareUrlPrefix}${this.getShareParameters()}&via=UltimateEars`;
        } else if (network === "pinterest") {
          url = `http://pinterest.com/pin/create/button/?url=${shareUrlPrefix}${this.getShareParameters()}&description=${twitterShareText}&media=${shareImageURL}`;
        }
        window.open(
          url,
          "popup",
          "location,status,scrollbars,resizable,width=500,height=300"
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/_variables.scss";

.share {
  background: $greyLight;
  color: $greyDark;
  padding: 1em;
  box-sizing: border-box;
  margin: 0 -1.5em -2em -1.5em;
  @media (min-width: 600px) {
    margin-top: 3em;
  }
  @media (min-width: 992px) {
    margin-top: 0;
    padding: 0;
    background: transparent;
  }
  &--standalone {
    background: transparent;
    margin: 3em 0 2em 0;
    padding: 0;
  }
  &__heading {
    text-transform: uppercase;
    text-align: center;

    @media (min-width: 992px) {
      margin-bottom: 1.5em;
      color: #000;
      .share--standalone & {
        margin-bottom: 0;
      }
    }
  }
  &__btns {
    list-style: none outside;
    margin: 0;
    display: flex;
    justify-content: center;
    margin-left: 1.5em;
    @media (min-width: 992px) {
      width: auto;
      display: block;
      margin-left: 0;
      .share--standalone & {
        display: flex;
        margin-left: 1.5em;
      }
    }
  }
  &__btn-item {
    margin-left: 1.5em;
    margin-right: 1.5em;
    &:last-child {
      margin-right: 0;
    }
    @media (min-width: 992px) {
      margin-bottom: 1.7em;
      &:last-child {
        margin: 0;
      }
      .share--standalone & {
        margin-bottom: 0;
        &:last-child {
          margin-left: 1.5em;
          margin-right: 0;
        }
      }
    }
  }
  button[disabled] {
    cursor: wait;
  }
}
.share-inner {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 992px) {
    display: block;
    margin: 0;
  }
  .share--standalone & {
    display: flex;
    margin-left: auto;
    margin-right: auto;
  }
}
.share-btn {
  max-width: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
  border: none;
  background: transparent none;
  cursor: pointer;

  &__img {
    transition: opacity 0.25s;
  }

  &:hover {
    .share-btn__img {
      opacity: 0.5;
    }
  }

  &__img {
    width: 100%;
    display: block;
    path {
      fill: $greyDark;
    }
    @media (min-width: 992px) {
    }
  }
}
</style>
